import {Injectable} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {VenueAddress} from "./venue-address.data";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class VenueAddressService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }


    async getVenueAddress(venueId: string): Promise<VenueAddress> {
        return firstValueFrom(this.http.get<VenueAddress>("/fonzie/customer-instance-venue/" + venueId + "/address", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async createVenueAddress(venueId: string, address: VenueAddress): Promise<VenueAddress> {
        return firstValueFrom(this.http.post<VenueAddress>("/fonzie/customer-instance-venue/" + venueId + "/address", address, {headers: this.auth.getHttpHeaderOptions()}));
    }

}
